/* KULT Bewertungen – assets/kult-bewertungen.js
 * Judge.me-Widget nachbessern: Datum deutsch (TT.MM.JJJJ), Initiale im Kreis statt Platzhalter-Avatar,
 * eigener Knopf „Bewertung schreiben“ öffnet das Judge.me-Formular. Greift auch nach Seitenwechsel/Sortierung. */
(function () {
  'use strict';
  if (window.KULT && window.KULT.bewertungen) return;
  window.KULT = window.KULT || {};

  function zwei(n) { return (n < 10 ? '0' : '') + n; }
  function datum(el) {
    var roh = el.getAttribute('datetime') || el.getAttribute('data-content');
    if (!roh) return;
    var t = new Date(roh.replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(t.getTime())) return;
    var s = zwei(t.getDate()) + '.' + zwei(t.getMonth() + 1) + '.' + t.getFullYear();
    if (el.textContent !== s) el.textContent = s;
  }
  function initiale(rev) {
    var i = rev.querySelector('.jdgm-rev__icon');
    var a = rev.querySelector('.jdgm-rev__author');
    if (!i || !a) return;
    var b = (a.textContent || '').trim().charAt(0).toUpperCase() || 'K';
    if (i.textContent.trim() !== b) i.textContent = b;
  }
  function pflege(w) {
    Array.prototype.forEach.call(w.querySelectorAll('time.jdgm-rev__timestamp'), datum);
    Array.prototype.forEach.call(w.querySelectorAll('.jdgm-rev'), initiale);
  }
  function start() {
    var w = document.getElementById('judgeme_product_reviews');
    if (!w) return;
    pflege(w);
    var offen = false;
    new MutationObserver(function () {
      if (offen) return;
      offen = true;
      requestAnimationFrame(function () { offen = false; pflege(w); });
    }).observe(w, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-kb-schreiben]');
    if (!knopf) return;
    e.preventDefault();
    var link = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');
    if (!link) { window.open(knopf.getAttribute('data-kb-alt'), '_blank', 'noopener'); return; }
    link.click();
    setTimeout(function () {
      var form = document.querySelector('#judgeme_product_reviews .jdgm-form-wrapper');
      var offen = !!(form && form.offsetHeight > 0);
      Array.prototype.forEach.call(document.querySelectorAll('[data-kb-schreiben]'), function (k) { k.textContent = offen ? 'Formular schließen' : 'Bewertung schreiben'; });
      if (!offen) return;
      var ziel = document.querySelector('#judgeme_product_reviews .jdgm-form-wrapper') || document.getElementById('judgeme_product_reviews');
      if (ziel) {
        var kopf = document.querySelector('.site-header--stuck');
        var y = ziel.getBoundingClientRect().top + window.pageYOffset - Math.max(kopf ? kopf.offsetHeight : 0, 130) - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 300);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { var w = document.getElementById('judgeme_product_reviews'); if (w) pflege(w); });
  window.KULT.bewertungen = { pflege: pflege };
})();
